import { useState } from 'react';
import { motion } from 'framer-motion';

interface ProductImageGalleryProps {
  images: Array<{ node: { url: string; altText: string | null } }>;
  title: string;
  imageAlts: string[];
}

export function ProductImageGallery({ images, title, imageAlts }: ProductImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="aspect-square overflow-hidden rounded-lg bg-secondary mb-4">
        {images[selectedImage]?.node ? (
          <img
            src={images[selectedImage].node.url}
            alt={imageAlts[selectedImage] || images[selectedImage].node.altText || title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-muted-foreground">No image</span>
          </div>
        )}
      </div>
      
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-2">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedImage(idx)}
              className={`flex-shrink-0 w-20 h-20 rounded-md overflow-hidden border-2 transition-colors ${
                selectedImage === idx ? 'border-bronze' : 'border-transparent'
              }`}
            >
              <img
                src={img.node.url}
                alt={imageAlts[idx] || img.node.altText || `${title} ${idx + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      )}
    </motion.div>
  );
}
